import { IGetProjectDetailParamsType } from "../type"

const ProjectBaseUrl = "/project"
export const ProjectEndpointCont = {
    addEditProjectUrl: `${ProjectBaseUrl}`,
    listProjectUrl: `${ProjectBaseUrl}/list`,
    deleteProjectUrl: `${ProjectBaseUrl}`,
    updateProjectUrl: `${ProjectBaseUrl}`,
}

export const getProjectDetailByIdUrl = (params: IGetProjectDetailParamsType) => {
    return `${ProjectBaseUrl}/${params.projectId}`
}